import axios from 'axios';

const helper = {
    getApiUrl() {
        let apiUrl = 'http://api-yellowtire:8888';

        if (location.origin.indexOf('yellowtire:8888') > -1) {
            apiUrl = 'http://api-yellowtire:8888';
        } else if (location.origin.indexOf('pos-yellowtire:8080') > -1) {
            apiUrl = 'http://api-yellowtire:8080';
        } else if (location.origin.indexOf('pos.yellowtire.com') > -1) {
            apiUrl = 'https://pos-api.yellowtire.com';
        }

        return apiUrl;
    },
    getAPI(api, path, header) {
        return new Promise((resolve) => {
            axios
                .get(api + path, header)
                .then((response) => { 
                    resolve(response);
                })
                .catch((error) => {
                    resolve(error.response);
                });
        });
    },
    postAPI(api, path, data, header) {
        return new Promise((resolve) => {
            axios
                .post(api + path, data, header)
                .then((response) => { 
                    resolve(response);
                })
                .catch((error) => {
                    resolve(error.response);
                });
        });
    },
    generateGUID() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
			const random = Math.random() * 16 | 0;
			const value = char === 'x' ? random : (random & 0x3 | 0x8);

			return value.toString(16);
		});
	},
    getClientTime() {
        return new Date().getTime();
    },
    cloneObject(object) {
        return JSON.parse(JSON.stringify(object));
    },
    getQueryString(key) {
        String.prototype.getValueByKey = function (k) {
            const pattern = new RegExp('\\b' + k + '\\b', 'gi');
            return this.search(pattern) != -1 ? decodeURIComponent(this.substr(this.search(pattern) + k.length + 1).substr(0, this.substr(this.search(pattern) + k.length + 1).search(/(&|;|$)/))) : "";
        };
    
        return window.location.href.getValueByKey(key);
    },
    getCommaNumber(value) {
        if (value) {
            const parts = value.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            return parts.join('.');
        }

        return value;
    },
    getLeadingZero(value, size) {
        let number = value + '';

        while (number.length < size) {
            number = '0' + number;
        }
        
        return number;
    },
    getWeekNumber(date) {
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

        date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));

        const yearStart = new Date(Date.UTC(date.getUTCFullYear(),0,1));
        const weekNo = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
        
        return [date.getUTCFullYear().toString().substr(-2), weekNo];
    },
    getHeaderToken() {
        return {
            headers: { Authorization: 'Bearer ' + localStorage.token }
        };
    },
}

export default helper;